import { VStack, Text, Heading, Box, Center } from 'native-base';
import { closeModal, openModal, toggleCreatingRoom, useAppDispatch } from '@breakroom-nx/redux';
import { shuffleColor } from '@breakroom-nx/classes';
import { ModalWrapper, PrimaryButton } from '../../';

export function NoRoomsFound() {
  const dispatch = useAppDispatch();

  return (
    <ModalWrapper>
      <VStack
        bg={'surface.100'}
        p={7}
        rounded={'2xl'}
        width={'full'}
        space={5}
        alignItems={'center'}
        alignContent={'center'}
      >
        <Box size={32} alignItems={'center'} alignContent={'center'}>
          <Center height={'full'} width={'full'}>
            <Box
              position={'absolute'}
              rounded={'full'}
              alignSelf={'center'}
              bg={shuffleColor()}
              alignItems={'center'}
              justifyContent={'center'}
              size={'70%'}
            >
              <Text bg={'transparent'} fontSize={32}>
                {`😔`}
              </Text>
            </Box>
          </Center>
        </Box>
        <VStack space={5}>
          <Heading fontSize={30} lineHeight={34} textAlign={'center'}>
            No Rooms Found Here
          </Heading>
          <Text
            textAlign={'center'}
            fontSize={16}
            lineHeight={21}
            fontWeight={200}
            color={'surface.600'}
          >
            No rooms were found in this map area. You can pan over another part
            of the map or zoom out further for better results. You can also be a
            pioneer and create a room right here in the center of your current
            map view. Start something here and talk directly to the locals!
          </Text>
        </VStack>

        <VStack space={5}>
          <VStack space={5}>
            <PrimaryButton
              text="Create Room Here"
              onPress={() => {
                dispatch(closeModal());
                dispatch(toggleCreatingRoom(true));
                dispatch(openModal({ modalType: 'Randomizer' }));
              }}
            />
          </VStack>
        </VStack>
      </VStack>
    </ModalWrapper>
  );
}

export default NoRoomsFound;
